import { render } from "./bancomatPay.vue?vue&type=template&id=d477d2a2&bindings={\"navigate\":\"props\",\"navRoute\":\"options\"}"
import script from "./bancomatPay.vue?vue&type=script&lang=js"
export * from "./bancomatPay.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./bancomatPay.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script